// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"dac9a9b6","453":"03346f77","455":"fa1a2795","977":"9e3561f6"}[chunkId] + ".chunk.js";
};